import { useMemo } from "react";

import { useEnhancedImageSource } from "@design-lab/entities/artwork";

import { SHIRT_TAB_IDS } from "./types/TabTypes";
import { useArtworkSelection } from "./useArtworkSelection";

/**
 * Custom hook to detect restorable or active upload artwork on both sides.
 */
export function useArtworkDetection() {
  const { getActiveSelection } = useArtworkSelection();

  // Form state - for restoration after reload (persistent data)
  const { artworkId: frontFormArtworkId } = useEnhancedImageSource({
    side: SHIRT_TAB_IDS.FRONT
  });
  const { artworkId: backFormArtworkId } = useEnhancedImageSource({
    side: SHIRT_TAB_IDS.BACK
  });

  const restorableSides = useMemo(() => {
    const sides = [
      {
        id: SHIRT_TAB_IDS.FRONT,
        artworkId: Number(frontFormArtworkId) || null
      },
      {
        id: SHIRT_TAB_IDS.BACK,
        artworkId: Number(backFormArtworkId) || null
      }
    ];

    return sides.filter(side => side.artworkId && !getActiveSelection(side.id).activeSource);
  }, [frontFormArtworkId, backFormArtworkId, getActiveSelection]);

  const hasPendingRestore = useMemo(() => restorableSides.length > 0, [restorableSides]);

  return {
    restorableSides,
    hasPendingRestore
  };
}
